package horcrux.frontend.common.views.collections.editcollectionmenu

import horcrux.common.api.dtos.types.CollectionName
import horcrux.common.utils.eitherWay
import horcrux.frontend.common.BooleanState
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.HasViewName
import horcrux.frontend.common.MaybeState
import horcrux.frontend.common.views.collections.collectiondialogs.MetadataDetailsDialog
import horcrux.frontend.common.views.collections.collectiondialogs.displayString
import horcrux.frontend.common.views.components.containers.DialogAction
import horcrux.frontend.common.views.components.containers.DialogView
import mui.material.AlertColor
import mui.material.DialogContentText
import mui.material.DialogTitle
import react.FC
import react.PropsWithChildren

external interface EditPublicCollectionMenuProps : PropsWithChildren {
    var globalAppState: GlobalAppState
}

enum class ManagePublicCollectionMenuOptions(override val viewName: String) : HasViewName {
    COLLECTION_DETAILS("View Public Collection Details"),
    IMPORT_COLLECTION("Import Public Collection to Your Account");
}

val EditPublicCollectionMenu = FC<EditPublicCollectionMenuProps> { props ->
    val collectionMetadataMaybe =
        props.globalAppState.chatPageDataMaybeState.get()?.chatPageMetadata?.collectionMetadata
    val showCollectionDetailsDialogState = BooleanState()
    val showImportCollectionDialogState = BooleanState()
    val collectionNameMaybeState = MaybeState<CollectionName>()

    collectionMetadataMaybe?.let { collectionMetadata ->
        MetadataDetailsDialog {
            this.title = ManagePublicCollectionMenuOptions.COLLECTION_DETAILS.viewName
            this.detailsText = collectionMetadata.displayString
            this.showDialogState = showCollectionDetailsDialogState
        }

        DialogView {
            this.showDialogState = showImportCollectionDialogState
            this.title = ManagePublicCollectionMenuOptions.IMPORT_COLLECTION.viewName
            this.dialogActionsMaybe = listOf(
                DialogAction(buttonLabel = "Cancel") { _, _ -> showImportCollectionDialogState.setFalse() },
                DialogAction(buttonLabel = "Import") { showDialogState, isLoadingState ->
                    props.globalAppState.submitBackendAPIRequestAsync { backendClient ->
                        isLoadingState.setTrue()
                        props.globalAppState.updateBanner(AlertColor.info, "Importing collection to your account")
                        backendClient
                            .importCollectionToAccount(collectionMetadata.id, collectionNameMaybeState.get())
                            .onRight {
                                props.globalAppState.updateBanner(
                                    AlertColor.success,
                                    "Successfully imported this collection to your account!"
                                )
                            }
                            .eitherWay {
                                isLoadingState.setFalse()
                                showDialogState.setFalse()
                            }
                            .bind()
                    }
                },
            )
            DialogTitle { +ManagePublicCollectionMenuOptions.IMPORT_COLLECTION.viewName }
            DialogContentText { +"Once imported you will be able to interact with it from your private account. You will be able to import new documents and continue chatting with it." }
            EditCollectionName { this.textFieldValueMaybeState = collectionNameMaybeState }
        }
    }

    EditCollectionMenu {
        this.globalAppState = props.globalAppState
        this.menuItemDataList = listOf(
            MenuItemData(
                ManagePublicCollectionMenuOptions.COLLECTION_DETAILS,
                collectionMetadataMaybe
            ) { closeMenu ->
                collectionMetadataMaybe?.let {
                    showCollectionDetailsDialogState.setTrue()
                    closeMenu()
                }
            },
            MenuItemData(ManagePublicCollectionMenuOptions.IMPORT_COLLECTION, collectionMetadataMaybe) { closeMenu ->
                collectionMetadataMaybe?.let {
                    showImportCollectionDialogState.setTrue()
                    closeMenu()
                }
            },
        )
    }
}

